import { create } from 'zustand';

interface FractionationAlertModalStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const useFractionationAlertModal = create<FractionationAlertModalStore>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false })
}));
